import { createSkyTwinTether } from './238-sky-twin-tether.mjs';
import { createSkyVesperEffects } from './233-sky-vesper-effects.mjs';
import { createSkyScrapMagnet } from './232-sky-scrap-magnet.mjs';
import { createSkyOrchidEffects } from './230-sky-orchid-effects.mjs';
import { createSkyBrideSearchlights } from './229-sky-bride-searchlights.mjs';
import { createSkyPrismOptics } from './228-sky-prism-optics.mjs';
import { createSkyFlightCourseArt } from './215-sky-flight-course-art.mjs';
import { createSkyReticle } from './135-sky-reticle.mjs';
import { createSkyObjectiveZones } from './186-sky-objective-zones.mjs';
import { createSkyCoolantStreams } from './224-sky-coolant-streams.mjs';

/** Small scene presentation resources share the renderer's ownership set.
 * Gameplay state remains in the existing domain and individual draw owners. */
export function createSkySceneDetails(T, scene, own, reduced) {
  const sight = createSkyReticle(T, own);
  const objectiveZones = createSkyObjectiveZones(T, scene, own);
  const flightCourseArt = createSkyFlightCourseArt(T, scene, own);
  const prismOptics = createSkyPrismOptics(T, scene, own);
  const coolantStreams = createSkyCoolantStreams(T, scene, own, reduced);
  const brideSearchlights = createSkyBrideSearchlights(T, scene, own, reduced);
  const orchidEffects = createSkyOrchidEffects(T, scene, own, reduced);
  const vesperEffects = createSkyVesperEffects(T, scene, own, reduced);
  const scrapMagnet = createSkyScrapMagnet(T, scene, own, reduced);
  const twinTether = createSkyTwinTether(T, scene, own, reduced);
  const encounterEffects = {
    draw(state, visible = true) {
      prismOptics.draw(state, visible);
      coolantStreams.draw(state, visible);
      brideSearchlights.draw(state, visible);
      orchidEffects.draw(state, visible);
      vesperEffects.draw(state, visible);
      scrapMagnet.draw(state, visible);
      twinTether.draw(state, visible);
    },
    diagnostics() {
      return {
        coolant: coolantStreams.diagnostics?.(),
        orchid: orchidEffects.diagnostics(),
        vesper: vesperEffects.diagnostics(),
        scrap: scrapMagnet.diagnostics(),
        twins: twinTether.diagnostics(),
      };
    },
  };
  const ringGeometry = own(new T.TorusGeometry(1.35, 0.075, 8, 48));
  const ringMaterial = own(
    new T.MeshStandardMaterial({
      color: '#ffe0a0',
      emissive: '#ffb648',
      emissiveIntensity: 2,
      metalness: 0.65,
      roughness: 0.25,
    }),
  );
  return {
    encounterEffects,
    prismOptics,
    sight,
    objectiveZones,
    flightCourseArt,
    coolantStreams,
    ringGeometry,
    ringMaterial,
  };
}

/** Only the active sector's source-backed approach props enter the draw list. */
export function skyApproachSceneItems(state) {
  if (state.boss) return [];
  const lesson =
    state.twinLesson?.sector === state.sector
      ? state.twinLesson
      : state.vesperLesson?.sector === state.sector
        ? state.vesperLesson
        : null;
  return lesson?.props ?? [];
}
